function getSharedWorker() {
    return new SharedWorker(new URL('workers/sharedWorker/index', import.meta.url), { name: 'AIQ SharedWorker', type: 'module' });
}

export default getSharedWorker;
